module.exports = __webpack_public_path__ + "static/7.Penny Stock Trading Risk Disclosure-086214f3af2324ad706db5e22f9dd645.pdf";